import { Repeat } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PunchupConfirmDialog } from 'features/common/components/Punchup/composites/dialogs/PunchupConfirmDialog';

interface UncancelModalProps {
	onConfirm: () => void;
	onClose: () => void;
	isLoading: boolean;
}

export const UncancelModal: FC<UncancelModalProps> = ({ onConfirm, onClose, isLoading }) => {
	const { t } = useTranslation();
	return (
		<PunchupConfirmDialog
			icon={<Repeat size={24} />}
			title={t('attendee-actions-uncancel-ticket', 'Un-Cancel Ticket')}
			text={t(
				'attendee-actions-uncancel-confirm',
				'The ticket will be reinstated and the attendee will regain access to the event.'
			)}
			secondaryText={t(
				'attendee-actions-uncancel-secondary',
				'Un-cancelling reclaims the seat that was freed when this ticket was cancelled, reducing available inventory by one. If the event has since sold out, the seat count will adjust to reflect the reinstated ticket.'
			)}
			collapsibleSecondary
			isLoading={isLoading}
			buttons={[
				{ label: t('cancel', 'Cancel'), variant: 'secondary', onClick: onClose },
				{ label: t('confirm', 'Confirm'), variant: 'primary', onClick: onConfirm },
			]}
		/>
	);
};
